import React from 'react';
import PropTypes from 'prop-types';
import partialRight from 'lodash.partialright';
import { connect } from 'react-redux';
import {
    FETCH_KEYWORDS,
    FETCH_GEO_REGIONS,
} from '@finn-no/redux-career/actions/types';
import * as actions from '@finn-no/redux-career/actions';
import { TwoSteps } from '@finn-no/career-preferences-prompt';
import analytics, {
    CAREER_MARKET_STEP,
    CAREER_MARKET_EXIT,
} from '../analytics-actions';

const TwoStepsWrapped = props => {
    if (props.shouldPrompt) {
        return (
            <div className="mod shadow">
                <div className="inner">
                    <div className="bd">
                        <TwoSteps {...props} />
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

TwoStepsWrapped.propTypes = {
    shouldPrompt: PropTypes.bool.isRequired,
};

const ctx = { location: 'frontpage' };

export default connect(
    state => ({
        keywords: state.keywords,
        keywordPreferences: state.keywordPreferences,
        geoRegions: state.geoRegions,
        geoRegionPreferences: state.geoRegionPreferences,
    }),
    {
        mockFetchKeywords: () => ({ type: FETCH_KEYWORDS }),
        fetchKeywords: partialRight(actions.keywords.fetch, ctx),
        changeKeywordQuery: partialRight(actions.keywords.changeQuery, ctx),
        fetchKeywordPreferences: partialRight(
            actions.keywordPreferences.fetch,
            ctx
        ),
        addKeywordPreference: partialRight(actions.keywordPreferences.add, ctx),
        removeKeywordPreference: partialRight(
            actions.keywordPreferences.remove,
            ctx
        ),
        addGeoRegionPreference: partialRight(
            actions.geoRegionPreferences.add,
            ctx
        ),
        removeGeoRegionPreference: partialRight(
            actions.geoRegionPreferences.remove,
            ctx
        ),
        mockFetchGeoRegions: () => ({ type: FETCH_GEO_REGIONS }),
        fetchGeoRegions: partialRight(actions.geoRegions.fetch, ctx),
        changeGeoRegionQuery: partialRight(actions.geoRegions.changeQuery, ctx),
        fetchGeoRegionPreferences: partialRight(
            actions.geoRegionPreferences.fetch,
            ctx
        ),
        trackStep: step => analytics(CAREER_MARKET_STEP, { step }),
        trackExit: step => analytics(CAREER_MARKET_EXIT, { step }),
    }
)(TwoStepsWrapped);



// WEBPACK FOOTER //
// ./containers/CareerPreferencesMarketPage.jsx